import React from 'react';

import Intro from './Intro';
import { FullWidthPanel, ImageCollagePanel } from '../../../components/HorizontalCarousel/panels';

import './MGPanels.css';
import Three from './Three';

const MGPanels: React.FC = () => {
  return (
    <div className="mg-panels">
      <Intro />
      <ImageCollagePanel imgContent='/assets/images/frame-3960---Copy.png' />
      <FullWidthPanel imgSrc='/assets/images/meetings-events/33d5b125b1c7c803c9ceee3a7ef98e88d3a63f38.png' imgAlt='Pool area' width='50vw' />
      <Three />
      <FullWidthPanel imgSrc='/assets/images/meetings-events/d8dbaa08f904fa823929d0f428310920f12625c7.png' imgAlt='Awasi Atacama pool area' />
    </div>
  );
};

export default MGPanels;